<template>
  <div class="p--40px">
    <h1 class="font--32px lh--1 pb--20px">RESOURCE LIST</h1>

    <div class="list-type-a view--thum mobile:columns--6 mobile:gutter--md thum--xl view--list-name view--checkbox title--xs">
      <ul class="list clearfix">

        <li
          class="list__item clearfix"
          :key="row.seq"
          v-for="row in resources.rows"
        >
          <span class="list__item-thum">
            <span
              class="list__item-thum-img"
              :style="`background-image:url(/api/resources/files/${row.fileName});`"
            ></span>
          </span>
          <div class="list__content">
            <span class="list__content-link clearfix">
              <div class="list__head clearfix">
                <span class="list__checkbox">
                  <form-checkbox
                    v-model="row.selected"
                    :true-value="true"
                    :false-value="false"
                  ></form-checkbox>
                </span>
                <button class="btn btn--xxxs gray lighten-3 btn--radius-md float--right text--middle text--gray text--darken-1">Clip Copy</button>
                <span class="list__notice">공지</span>
                <!-- <span class="list__name">{{row.filter}}</span> -->
                <span class="list__secret">
                  <i class="material-icons">lock</i><span>비밀글</span>
                </span>
              </div>
              <div class="list__body pt--16px">
                <strong class="list__title">
                  <span class="list__number">1</span>{{row.title}}
                  {{row.fileName}}
                </strong>
                <p class="list__text"></p>
              </div>
            </span>
            <div class="list__foot clearfix">
              <span class="list__user-name">by. 홍길동</span>
              <span class="list__date">2019.01.01</span>
            </div>
          </div>
          <span class="list__arrow-deco">
            <i class="material-icons">arrow_forward</i>
          </span>
        </li>

      </ul>
    </div>

    <div class="text--center py--30px position--relative px--200px">
      <div class="position--absolute right--0px top--14px">
        <span class="inline-block btn btn--xxxl black text--white">이미지 등록</span>
        <resource-upload
          name="fileUpload"
          @uploading="onUploading"
          @uploaded="onUploaded"
        ></resource-upload>
      </div>

      <pagination :total="resources.count" />

      <div class="position--absolute left--0px top--14px">
        <form-button
          label="선택삭제"
          class="btn btn--xxxl border border--gray border--lighten-2"
          @click="removeSelected"
        ></form-button>
      </div>
    </div>
  </div>
</template>

<script>
// import Sortable from 'sortablejs'
export default {
  data () {
    return {
      selected: false,
      resources: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    async search () {
      this.resources = await this.$search('/api/resources')
    },
    async removeSelected () {
      const ret = await this.$removeSelected(
        row => `/api/resources/${row.seq}`,
        this.resources
      )
      ret && await this.search()
    },
    async selectAll () {
      this.resources = await this.$selectAll(this.resources)
    },
    async onChange (row) {
      try {
        console.log('change', row)
        const payload = {
          useFlag: row.useFlag
        }
        await this.$http.patch(`/api/resources/${row.seq}`, payload)
        this.search()
      } catch (ex) {
        console.error(ex, ex.response)
      }
    },
    goView (seq) {
      this.$router.push({
        name: 'adminResourceEdit',
        params: { seq }
      })
    },
    onUploaded (file) {
      console.log('onUploaded', file)
      this.search()
      // this.row = file
    },
    onUploading (uploadStatus) {
      console.log('onUploading', uploadStatus)
      // this.uploadStatus = uploadStatus
    }
  },
  components: {
    ResourceUpload: () => import('./ResourceUpload'),
    Pagination: () => import('@/component/ui2/pagination/Pagination'),
    FormButton: () => import('@/component/ui2/button/FormButton'),
    FormCheckbox: () => import('@/component/ui2/form/FormCheckbox')
    // FormToggle: () => import('@/component/ui2/form/FormToggle')
  }
}
</script>
